import React, { useState, useEffect } from 'react';
import AppNav from './AppNav';
import { useRipple } from '../hooks/useRipple';
import { fetchLivePrediction } from '../Livepriceservice';
import './styles/clickEffects.css';

const COMMODITIES = [
  'Bananas','Beans (red)','Beans (white)','Bread','Cassava meal (gari yellow)',
  'Cowpeas (brown)','Cowpeas (white)','Cowpeas','Eggs','Fish','Fuel (diesel)',
  'Fuel (petrol/gasoline)','Gari (white)','Groundnuts (shelled)','Groundnuts',
  'Maize flour','Maize (white)','Maize (yellow)','Maize','Meat (beef)','Meat (goat)',
  'Milk powder','Millet','Oil (palm)','Oil (vegetable)','Onions','Oranges',
  'Rice (imported)','Rice (local)','Rice (milled local)','Salt','Sorghum (brown)',
  'Sorghum (white)','Sorghum','Spinach','Sugar','Tomatoes','Watermelons','Yam',
];

const STATES = [
  'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa','Benue','Borno',
  'Cross River','Delta','Ebonyi','Edo','Ekiti','Enugu','FCT (Abuja)','Gombe',
  'Imo','Jigawa','Kaduna','Kano','Katsina','Kebbi','Kogi','Kwara','Lagos',
  'Nasarawa','Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers','Sokoto',
  'Taraba','Yobe','Zamfara',
];

const MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December',
];
const YEARS = [2024, 2025, 2026, 2027, 2028];

export const COMMODITY_UNITS = {
  'Rice (local)':'per kg','Rice (milled local)':'per kg','Rice (imported)':'per kg',
  'Maize':'per kg','Maize (white)':'per kg','Maize (yellow)':'per kg','Maize flour':'per kg',
  'Beans (white)':'per kg','Beans (red)':'per kg','Cowpeas':'per kg',
  'Cowpeas (white)':'per kg','Cowpeas (brown)':'per kg','Yam':'per medium tuber (~3kg)',
  'Cassava meal (gari yellow)':'per kg (yellow gari)','Gari (white)':'per kg (white gari)',
  'Oil (palm)':'per litre','Oil (vegetable)':'per litre','Groundnuts':'per kg',
  'Groundnuts (shelled)':'per kg','Sorghum':'per kg','Sorghum (brown)':'per kg',
  'Sorghum (white)':'per kg','Millet':'per kg','Tomatoes':'per kg','Onions':'per kg',
  'Fish':'per kg (dried/smoked)','Meat (beef)':'per kg (boneless)','Meat (goat)':'per kg',
  'Eggs':'per dozen (12 eggs)','Bread':'per 500g loaf','Milk powder':'per 400g tin',
  'Sugar':'per kg','Salt':'per kg','Spinach':'per bunch','Bananas':'per bunch (~6–8 fingers)',
  'Oranges':'per dozen','Watermelons':'per medium fruit (~4kg)',
  'Fuel (petrol/gasoline)':'per litre','Fuel (diesel)':'per litre',
};

/* ── Price estimation (demo fallback) ─────────────────── */
const BASE_PRICES = {
  'Rice (local)':1900,'Rice (milled local)':1980,'Rice (imported)':1220,
  'Maize':820,'Maize (white)':810,'Maize (yellow)':830,'Maize flour':950,
  'Beans (white)':900,'Beans (red)':950,'Cowpeas':1260,'Cowpeas (white)':1210,
  'Cowpeas (brown)':1260,'Yam':3800,'Cassava meal (gari yellow)':822,
  'Gari (white)':772,'Oil (palm)':440,'Oil (vegetable)':380,'Groundnuts':450,
  'Groundnuts (shelled)':500,'Sorghum':550,'Sorghum (brown)':540,
  'Sorghum (white)':560,'Millet':600,'Tomatoes':1300,'Onions':1450,
  'Fish':4000,'Meat (beef)':6200,'Meat (goat)':6800,'Eggs':3200,
  'Bread':1200,'Milk powder':1250,'Sugar':1800,'Salt':500,'Spinach':400,
  'Bananas':1200,'Oranges':1800,'Watermelons':3800,
  'Fuel (petrol/gasoline)':1310,'Fuel (diesel)':1875,
};
const ZONE = {
  'North-West':['Jigawa','Kaduna','Kano','Katsina','Kebbi','Sokoto','Zamfara'],
  'North-East':['Adamawa','Bauchi','Borno','Gombe','Taraba','Yobe'],
  'North-Central':['Benue','FCT (Abuja)','Kogi','Kwara','Nasarawa','Niger','Plateau'],
  'South-West':['Ekiti','Lagos','Ogun','Ondo','Osun','Oyo'],
  'South-East':['Abia','Anambra','Ebonyi','Enugu','Imo'],
  'South-South':['Akwa Ibom','Bayelsa','Cross River','Delta','Edo','Rivers'],
};
const ZONE_MULTIPLIERS = {
  'Rice (local)':{'North-East':0.88,'North-West':0.92,'North-Central':1.07,'South-West':1.05,'South-East':1.22,'South-South':1.10},
  'Rice (imported)':{'North-East':0.90,'North-West':0.94,'North-Central':1.00,'South-West':1.05,'South-East':1.18,'South-South':1.12},
  'Maize':{'North-East':0.80,'North-West':0.82,'North-Central':0.88,'South-West':1.05,'South-East':1.20,'South-South':1.12},
  'Beans (red)':{'North-East':0.78,'North-West':0.80,'North-Central':0.95,'South-West':1.12,'South-East':1.18,'South-South':1.10},
  'Tomatoes':{'North-East':0.60,'North-West':0.62,'North-Central':0.85,'South-West':1.00,'South-East':1.28,'South-South':1.20},
  'Onions':{'North-East':0.55,'North-West':0.50,'North-Central':0.85,'South-West':1.10,'South-East':1.35,'South-South':1.25},
  'Oil (palm)':{'North-East':1.20,'North-West':1.18,'North-Central':1.10,'South-West':1.05,'South-East':0.85,'South-South':0.70},
  'Groundnuts':{'North-East':0.82,'North-West':0.82,'North-Central':0.90,'South-West':1.05,'South-East':1.10,'South-South':1.08},
  'Meat (beef)':{'North-East':0.90,'North-West':0.92,'North-Central':0.98,'South-West':1.05,'South-East':1.08,'South-South':1.10},
  'Fish':{'North-East':1.05,'North-West':1.08,'North-Central':1.02,'South-West':0.98,'South-East':0.92,'South-South':0.88},
  'Fuel (petrol/gasoline)':{'North-East':1.07,'North-West':1.06,'North-Central':1.02,'South-West':0.98,'South-East':1.02,'South-South':1.03},
  'Fuel (diesel)':{'North-East':1.07,'North-West':1.06,'North-Central':1.02,'South-West':0.97,'South-East':1.02,'South-South':1.03},
};
const STATE_OVERRIDES = {
  'Lagos':{'Rice (local)':69500/50,'Maize':9000/100,'Groundnuts':45000/100,'Oil (palm)':12000/25,'Onions':25000/100,'Tomatoes':7500/40},
  'Kano':{'Rice (local)':69000/50,'Maize':9400/100,'Groundnuts':40500/100,'Oil (palm)':10500/25,'Onions':10000/100,'Tomatoes':15000/40},
  'Abia':{'Beans (white)':5050/5.5,'Rice (local)':80000/50,'Groundnuts':47000/100,'Oil (palm)':5000/25,'Maize':11000/100,'Onions':29000/100,'Tomatoes':12000/40},
  'Enugu':{'Rice (local)':80000/50,'Maize':16500/100,'Groundnuts':43000/100,'Onions':15000/100,'Tomatoes':13000/40},
  'Benue':{'Rice (local)':65000/50,'Maize':6000/100,'Groundnuts':47000/100,'Oil (palm)':10000/25,'Onions':27000/100,'Tomatoes':22000/40},
};
const SEASONAL = {
  'Yam':[1.20,1.25,1.20,1.15,1.05,1.00,0.95,0.90,0.88,0.90,0.95,1.10],
  'Tomatoes':[1.15,1.10,1.05,1.00,1.05,1.10,1.00,0.90,0.88,0.85,0.88,1.00],
  'Maize':[1.10,1.15,1.12,1.08,1.05,0.95,0.90,0.85,0.88,0.90,0.95,1.05],
};

function getZone(state) {
  for (const [zone, states] of Object.entries(ZONE)) {
    if (states.includes(state)) return zone;
  }
  return 'South-West';
}

function estimatePrice(commodity, state, month, year) {
  let base = BASE_PRICES[commodity] ?? 1000;
  const stateOverride = STATE_OVERRIDES[state]?.[commodity];
  if (stateOverride) {
    base = stateOverride;
  } else {
    const zone = getZone(state);
    const zoneMul = ZONE_MULTIPLIERS[commodity]?.[zone] ?? 1.0;
    base = base * zoneMul;
  }
  const seasonal = SEASONAL[commodity]?.[month - 1] ?? 1.0;
  base = base * seasonal;
  const inflationRate = commodity.startsWith('Fuel') ? 0.08 : 0.12;
  base = base * Math.pow(1 + inflationRate, year - 2026);
  return Math.round(base);
}

/* ── Mobile detection ────────────────────────────────── */
function useIsMobile(bp = 768) {
  const [m, setM] = React.useState(() => window.innerWidth <= bp);
  useEffect(() => {
    const h = () => setM(window.innerWidth <= bp);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [bp]);
  return m;
}

/* ── Step indicator component ────────────────────────── */
function StepDot({ number, status, isLive }) {
  // status: 'inactive' | 'active' | 'done' | 'error'
  const styles = {
    inactive: {
      background: 'rgba(10,46,20,0.07)',
      color: 'rgba(10,46,20,0.30)',
      border: '2px solid transparent',
    },
    active: {
      background: isLive ? '#166534' : '#0a2e14',
      color: isLive ? '#86efac' : '#d4a017',
      border: '2px solid transparent',
    },
    done: {
      background: isLive ? '#166534' : '#0a2e14',
      color: '#22c55e',
      border: '2px solid transparent',
    },
    error: {
      background: '#fff',
      color: '#dc2626',
      border: '2px solid #dc2626',
    },
  };
  return (
    <div style={{
      width: 30, height: 30, flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Space Grotesk, sans-serif', fontSize: 12, fontWeight: 800,
      transition: 'all 0.3s ease',
      ...styles[status],
    }}>
      {status === 'done' ? '✓' : number}
    </div>
  );
}

export default function PriceForm({
  onResult, onBack, priceMode = 'student',
  onModeToggle, onNavigate, user = null, onUserChange,
  initialCommodity = '',
}) {
  const [commodity, setCommodity] = useState(initialCommodity || '');
  const [state, setState] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState(2026);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focusedField, setFocusedField] = useState(null);

  // Show a one-time "select state & time" hint if we arrived with a pre-filled commodity
  const [showPreFillHint, setShowPreFillHint] = useState(!!initialCommodity);

  // Sync initialCommodity into state whenever it changes (e.g. navigating from PricesPanel)
  useEffect(() => {
    if (initialCommodity) {
      setCommodity(initialCommodity);
      setState('');
      setMonth('');
      setShowPreFillHint(true);
    }
  }, [initialCommodity]);

  useEffect(() => {
    if (showPreFillHint) {
      const t = setTimeout(() => setShowPreFillHint(false), 6000);
      return () => clearTimeout(t);
    }
  }, [showPreFillHint]);

  // Which fields have been touched with an error (for red step + shake)
  const [errorFields, setErrorFields] = useState([]); // e.g. ['commodity','state','month']
  const [shakeKey, setShakeKey] = useState(0); // increment to re-trigger shake

  const isMobile = useIsMobile();
  const isLive = priceMode === 'live';
  const triggerRipple = useRipple();

  // Derived current step: 1=commodity, 2=state, 3=month, 4=ready
  const currentStep = !commodity ? 1 : !state ? 2 : !month ? 3 : 4;

  function getStepStatus(stepNum) {
    if (errorFields.includes(stepNum)) return 'error';
    if (stepNum < currentStep) return 'done';
    if (stepNum === currentStep) return 'active';
    return 'inactive';
  }

  function triggerShake(fields) {
    setErrorFields(fields);
    setShakeKey(k => k + 1);
  }

  function clearFieldError(field) {
    setErrorFields(prev => prev.filter(f => f !== field));
    setError('');
  }

  const handleSubmit = async () => {
    // Validate in order — jump to first missing
    if (!commodity) {
      setError('Please select a commodity first.');
      triggerShake([1]);
      return;
    }
    if (!state) {
      setError('Please select a state.');
      triggerShake([2]);
      return;
    }
    if (!month) {
      setError('Please select a forecast month.');
      triggerShake([3]);
      return;
    }
    setError('');
    setErrorFields([]);
    setLoading(true);

    try {
      if (isLive) {
        const data = await fetchLivePrediction({ commodity, state, month, year });
        onResult({
          commodity, state, month, year,
          unit: COMMODITY_UNITS[commodity] ?? 'per unit',
          source: 'Live Market Intelligence',
          ...data,
        });
      } else {
        try {
          const res = await fetch('http://localhost:5000/api/predict', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ commodity, state, month: MONTHS.indexOf(month) + 1, year }),
          });
          if (!res.ok) throw new Error('API error');
          const data = await res.json();
          onResult({ commodity, state, month, year, unit: COMMODITY_UNITS[commodity] ?? 'per unit', ...data });
        } catch {
          // Demo fallback — no backend notification shown
          const monthNum = MONTHS.indexOf(month) + 1;
          const predicted = estimatePrice(commodity, state, monthNum, year);
          const prevMonthNum = monthNum === 1 ? 12 : monthNum - 1;
          const prevYear = monthNum === 1 ? year - 1 : year;
          const prevMonth = estimatePrice(commodity, state, prevMonthNum, prevYear);
          const pctChange = (((predicted - prevMonth) / prevMonth) * 100).toFixed(2);
          const confidence = (82 + Math.random() * 10).toFixed(1);
          onResult({
            commodity, state, month, year,
            unit: COMMODITY_UNITS[commodity] ?? 'per unit',
            predicted_price: predicted,
            prev_month_price: prevMonth,
            pct_change: pctChange,
            confidence,
            trend: parseFloat(pctChange) > 3 ? 'rising' : parseFloat(pctChange) < -3 ? 'falling' : 'stable',
            demo: true,
          });
        }
      }
    } catch (err) {
      setError(`Prediction failed: ${err.message}. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  /* ── Styles ──────────────────────────────────────── */
  const navH = isMobile ? 60 : 72;

  const fieldBase = {
    width: '100%', height: 52,
    padding: '0 40px 0 14px',
    border: '1.5px solid rgba(10,46,20,0.15)',
    borderRadius: 2, fontSize: 14, color: '#1c1b1b',
    background: '#f6f3f2', outline: 'none',
    fontFamily: 'Manrope, sans-serif',
    transition: 'border-color 0.2s, box-shadow 0.2s, background 0.2s',
    appearance: 'none', WebkitAppearance: 'none', cursor: 'pointer',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='7' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%230a2e14' stroke-width='1.8' fill='none' stroke-linecap='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat', backgroundPosition: 'right 14px center',
    boxSizing: 'border-box',
  };

  const getFocused = (field) =>
    focusedField === field
      ? { borderColor: '#d4a017', boxShadow: '0 0 0 3px rgba(212,160,23,0.15)', background: '#ffffff' }
      : {};

  const getErrorBorder = (field) =>
    errorFields.includes(field)
      ? { borderColor: '#dc2626' }
      : {};

  const labelStyle = {
    display: 'flex', alignItems: 'center', gap: 7,
    fontSize: '0.7rem', fontWeight: 700, color: '#795900',
    marginBottom: 7, textTransform: 'uppercase', letterSpacing: '0.1em',
    fontFamily: 'Space Grotesk, sans-serif',
  };

  // Disabled group style
  const disabledGroup = (disabled) => disabled
    ? { opacity: 0.45, pointerEvents: 'none' }
    : { opacity: 1, pointerEvents: 'auto', transition: 'opacity 0.3s' };

  return (
    <div style={{ background: '#fcf9f8', minHeight: '100vh', fontFamily: 'Manrope, sans-serif' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Epilogue:wght@700;900&family=Manrope:wght@400;500;600;700&family=Space+Grotesk:wght@500;600;700&display=swap');
        @keyframes fadeInUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:none; } }
        @keyframes spin { to { transform:rotate(360deg); } }
        @keyframes pulse { 0%,100% { opacity:1; } 50% { opacity:0.4; } }
        @keyframes shimmerGold { 0% { background-position:-200% center; } 100% { background-position:200% center; } }
        @keyframes shake { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-6px)} 40%,80%{transform:translateX(6px)} }
        .pf-field-wrap:focus-within .pf-label { color:#d4a017 !important; }
        .pf-submit:hover:not(:disabled) { transform:translateY(-2px) !important; box-shadow:10px 10px 0 0 rgba(10,46,20,0.13) !important; }
        .pf-submit:active:not(:disabled) { transform:translateY(0) !important; }
        .shake-anim { animation: shake 0.4s ease; }
      `}</style>

      <AppNav
        activePage="predict"
        priceMode={priceMode}
        onModeToggle={onModeToggle}
        onNavigate={onNavigate}
        isMobile={isMobile}
        user={user}
        onUserChange={onUserChange}
      />
      <div style={{ height: navH }} />

      <main style={{ maxWidth: 680, margin: '0 auto', padding: 'clamp(1.5rem,4vw,3rem) clamp(0.9rem,4vw,1.5rem)' }}>

        {/* ── Pre-fill hint banner (shown when arriving from Prices panel) ── */}
        {showPreFillHint && initialCommodity && (
          <div style={{
            marginBottom: '1.25rem',
            background: '#0a2e14',
            border: '2px solid #d4a017',
            borderRadius: 0,
            padding: '12px 16px',
            display: 'flex', alignItems: 'center', gap: 12,
            boxShadow: '4px 4px 0 rgba(212,160,23,0.2)',
            animation: 'fadeInUp 0.4s cubic-bezier(.34,1.56,.64,1) both',
          }}>
            <div style={{
              width: 36, height: 36, flexShrink: 0,
              background: 'rgba(212,160,23,0.15)',
              border: '1.5px solid rgba(212,160,23,0.4)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <span style={{ fontSize: 18 }}>📍</span>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#d4a017', fontFamily: 'Epilogue, sans-serif', marginBottom: 2 }}>
                {initialCommodity} is pre-selected!
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', fontFamily: 'Manrope, sans-serif', lineHeight: 1.4 }}>
                Now choose your <strong style={{ color: '#fff' }}>State</strong> and the <strong style={{ color: '#fff' }}>month &amp; year</strong> you want to predict — then hit Predict.
              </div>
            </div>
            <button
              onClick={() => setShowPreFillHint(false)}
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 0, flexShrink: 0 }}
            >×</button>
          </div>
        )}

        {/* ── Hero image ── */}
        <div style={{
          width: '100%', marginBottom: '1.75rem',
          borderBottom: `3px solid ${isLive ? '#22c55e' : '#d4a017'}`,
          overflow: 'hidden', height: 90,
          animation: 'fadeInUp 0.5s ease both',
        }}>
          <img
            src="https://www.shutterstock.com/image-vector/glowing-green-financial-chart-rising-600nw-2678697777.jpg"
            alt="Market price forecast"
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
          />
        </div>

        {/* ── Badge + Heading ── */}
        <div style={{ marginBottom: '1.75rem', animation: 'fadeInUp 0.6s ease 0.05s both' }}>
          <h1 style={{
            fontFamily: 'Epilogue, sans-serif',
            fontSize: 'clamp(1.8rem,6vw,2.8rem)',
            fontWeight: 900, color: '#001805', lineHeight: 1.1,
            marginBottom: 10, letterSpacing: '-0.03em',
          }}>
            {isLive ? 'Live Market' : 'Price Forecasting'}<br />
            <span key={isLive ? 'live' : 'student'} style={{
              display: 'inline',
              background: isLive
                ? 'linear-gradient(135deg, #22c55e 0%, #86efac 50%, #22c55e 100%)'
                : 'linear-gradient(135deg, #d4a017 0%, #f5c842 50%, #d4a017 100%)',
              backgroundSize: '200% auto',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              color: 'transparent',
              animation: 'shimmerGold 3s linear infinite',
              paddingBottom: 2,
            }}>
              {isLive ? 'Prediction' : 'Engine'}
            </span>
          </h1>
          <p style={{ color: '#424841', fontSize: 14, lineHeight: 1.65, maxWidth: 460 }}>
            {isLive
              ? 'Predictions powered by live Nigerian market intelligence — current retail prices, inflation trends, and state-level supply chain data.'
              : 'Select a commodity, state, and target month. Our ML model trained on 24 years of WFP market data will forecast the price.'}
          </p>
        </div>

        {/* ── Form card ── */}
        <div style={{
          background: '#ffffff', border: '1px solid rgba(10,46,20,0.1)',
          borderTop: `3px solid ${isLive ? '#22c55e' : '#d4a017'}`,
          boxShadow: isLive ? '6px 6px 0 0 rgba(22,101,52,0.10)' : '6px 6px 0 0 rgba(10,46,20,0.08)',
          padding: 'clamp(1.25rem,4vw,2rem)',
          animation: 'fadeInUp 0.7s ease 0.1s both',
        }}>

          {/* Step indicators */}
          <div style={{
            display: 'flex', alignItems: 'center',
            marginBottom: '1.5rem', paddingBottom: '1.25rem',
            borderBottom: '1px dashed rgba(10,46,20,0.12)',
          }}>
            {[1, 2, 3, 4].map((n, i) => (
              <React.Fragment key={n}>
                <StepDot number={n} status={getStepStatus(n)} isLive={isLive} />
                {i < 3 && (
                  <div style={{
                    flex: 1, height: 1,
                    background: 'linear-gradient(90deg, rgba(10,46,20,0.1), rgba(212,160,23,0.18))',
                  }} />
                )}
              </React.Fragment>
            ))}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>

            {/* ── Step 1: Commodity ── */}
            <div className="pf-field-wrap">
              <label className="pf-label" style={labelStyle}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                Commodity Type
              </label>
              <select
                value={commodity}
                onChange={e => { setCommodity(e.target.value); clearFieldError(1); setState(''); setMonth(''); }}
                style={{ ...fieldBase, ...getFocused('commodity'), ...getErrorBorder(1) }}
                onFocus={() => setFocusedField('commodity')}
                onBlur={() => setFocusedField(null)}
              >
                <option value="">Select a commodity… ({COMMODITIES.length} available)</option>
                <optgroup label="Grains">
                  {['Maize','Maize (white)','Maize (yellow)','Maize flour','Millet','Rice (imported)','Rice (local)','Rice (milled local)','Sorghum','Sorghum (brown)','Sorghum (white)'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Legumes">
                  {['Beans (red)','Beans (white)','Cowpeas','Cowpeas (brown)','Cowpeas (white)','Groundnuts','Groundnuts (shelled)'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Tubers & Cassava">
                  {['Cassava meal (gari yellow)','Gari (white)','Yam'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Oils & Fats">
                  {['Oil (palm)','Oil (vegetable)'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Protein & Dairy">
                  {['Eggs','Fish','Meat (beef)','Meat (goat)','Milk powder'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Vegetables & Fruits">
                  {['Bananas','Onions','Oranges','Spinach','Tomatoes','Watermelons'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Staples">
                  {['Bread','Salt','Sugar'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
                <optgroup label="Fuel">
                  {['Fuel (diesel)','Fuel (petrol/gasoline)'].map(c => <option key={c}>{c}</option>)}
                </optgroup>
              </select>
              {commodity && (
                <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: '#15803d', fontWeight: 700, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '0.04em' }}>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#22c55e', display: 'inline-block' }} />
                  Price quoted {COMMODITY_UNITS[commodity] ?? 'per unit'}
                </div>
              )}
            </div>

            {/* ── Step 2: State ── */}
            <div className="pf-field-wrap" style={disabledGroup(!commodity)}>
              <label className="pf-label" style={labelStyle}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Target State
              </label>
              <select
                value={state}
                onChange={e => { setState(e.target.value); clearFieldError(2); setMonth(''); }}
                disabled={!commodity}
                style={{ ...fieldBase, ...getFocused('state'), ...getErrorBorder(2) }}
                onFocus={() => setFocusedField('state')}
                onBlur={() => setFocusedField(null)}
              >
                <option value="">Select a state…</option>
                {STATES.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>

            {/* ── Step 3: Month + Year ── */}
            <div className="pf-field-wrap" style={disabledGroup(!state)}>
              <label className="pf-label" style={labelStyle}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                Time Period
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <select
                  value={month}
                  onChange={e => { setMonth(e.target.value); clearFieldError(3); }}
                  disabled={!state}
                  style={{ ...fieldBase, ...getFocused('month'), ...getErrorBorder(3) }}
                  onFocus={() => setFocusedField('month')}
                  onBlur={() => setFocusedField(null)}
                >
                  <option value="">Month…</option>
                  {MONTHS.map(m => <option key={m}>{m}</option>)}
                </select>
                <select
                  value={year}
                  onChange={e => setYear(parseInt(e.target.value))}
                  disabled={!state}
                  style={{ ...fieldBase, ...getFocused('year') }}
                  onFocus={() => setFocusedField('year')}
                  onBlur={() => setFocusedField(null)}
                >
                  {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>

            {/* ── Error message (shake on each new trigger) ── */}
            {error && (
              <div
                key={shakeKey}
                className="shake-anim"
                style={{
                  background: '#fef2f2',
                  borderLeft: '4px solid #dc2626',
                  padding: '11px 14px',
                  fontSize: 13, color: '#b91c1c',
                  display: 'flex', alignItems: 'center', gap: 9,
                  borderRadius: '0 2px 2px 0',
                }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                {error}
              </div>
            )}

            {/* ── Submit button ── */}
            <button
              className="pf-submit"
              onClick={handleSubmit}
              disabled={loading}
              style={{
                width: '100%', height: 58,
                background: loading ? '#727970' : isLive ? '#166534' : '#0a2e14',
                color: isLive ? '#86efac' : '#d4a017',
                border: 'none', fontSize: 15, fontWeight: 800,
                cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: 'Epilogue, sans-serif', letterSpacing: '0.02em',
                transition: 'all 0.25s cubic-bezier(.22,.68,0,1.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                boxShadow: loading ? 'none' : isLive ? '6px 6px 0 0 rgba(22,101,52,0.18)' : '6px 6px 0 0 rgba(10,46,20,0.15)',
                borderRadius: 0,
              }}
            >
              {loading ? (
                <>
                  <span style={{
                    width: 17, height: 17,
                    border: `2px solid ${isLive ? 'rgba(134,239,172,0.3)' : 'rgba(212,160,23,0.3)'}`,
                    borderTopColor: isLive ? '#86efac' : '#d4a017',
                    borderRadius: '50%', display: 'inline-block',
                    animation: 'spin 0.7s linear infinite',
                  }} />
                  {isLive ? 'Fetching Live Market Data…' : 'Running Prediction…'}
                </>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                  {isLive ? 'Get Live Prediction' : 'Generate Prediction'}
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </>
              )}
            </button>
          </div>
        </div>

        {/* ── Info panel ── */}
        <div style={{
          marginTop: '1.25rem', padding: '1.1rem 1.25rem',
          background: isLive ? '#f0fdf4' : '#ffffff',
          borderLeft: `4px solid ${isLive ? '#22c55e' : '#d4a017'}`,
          border: `1px solid ${isLive ? 'rgba(34,197,94,0.2)' : 'rgba(10,46,20,0.1)'}`,
          boxShadow: '6px 6px 0 0 rgba(10,46,20,0.05)',
          animation: 'fadeInUp 0.8s ease 0.2s both',
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 11 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={isLive ? '#166534' : '#795900'} strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0, marginTop: 2 }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#001805', marginBottom: 5, fontFamily: 'Epilogue, sans-serif' }}>
                {isLive ? 'Live Intelligence Source' : 'Technical Specification'}
              </div>
              <p style={{ fontSize: 12, color: '#424841', lineHeight: 1.65, margin: 0 }}>
                {isLive
                  ? 'This mode uses AI market intelligence trained on current Nigerian price data from sources including NBS, WFP VAM, Jumia, and regional market reports.'
                  : 'Predictions use XGBoost regression trained on 24 years of WFP market data across Nigeria. Each of the 39 commodity models is individually trained. Demo fallback prices are calibrated to real NBS market data (Jan–Apr 2026).'}
              </p>
            </div>
          </div>
        </div>

      </main>
    </div>
  );
}